"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Allocation = void 0;
var buffer_1 = require("buffer");
var lodash_1 = require("lodash");
var Allocation = /** @class */ (function () {
    function Allocation(allocation) {
        this.allocation = allocation;
    }
    Allocation.read = function (buffer, offset) {
        var allocation = buffer.readUInt8(offset);
        offset++;
        return { allocation: new Allocation(allocation), offset: offset };
    };
    Allocation.fromHex = function (hex) {
        var buffer = buffer_1.Buffer.from(hex, 'hex');
        var allocation = Allocation.read(buffer, 0).allocation;
        return allocation;
    };
    Allocation.prototype.getAllocation = function () {
        if (!lodash_1.isUndefined(this.allocation))
            return this.allocation;
        throw new Error("allocation is not valid");
    };
    Allocation.prototype.getSize = function () {
        return 1;
    };
    Allocation.prototype.toJson = function () {
        return {
            allocation: this.getAllocation()
        };
    };
    Allocation.prototype.write = function (buffer, offset) {
        offset = buffer.writeUInt8(this.allocation, offset);
        return offset;
    };
    Allocation.prototype.serialize = function () {
        var size = this.getSize();
        var buffer = buffer_1.Buffer.alloc(size);
        this.write(buffer, 0);
        return buffer;
    };
    Allocation.prototype.toHex = function () {
        return this.serialize().toString('hex');
    };
    return Allocation;
}());
exports.Allocation = Allocation;
//# sourceMappingURL=Allocation.js.map